// extracted by mini-css-extract-plugin
module.exports = {"TitleInput":"NewName_TitleInput__soLxG","InputIcon":"NewName_InputIcon__JMtce","NewServiceInput":"NewName_NewServiceInput__UTMoL","Input":"NewName_Input__czSD6"};